import { faWandMagicSparkles } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, FormControlLabel, Grid, InputAdornment, Stack, Switch, TextField } from '@vapor/material'
import { FormItem } from 'hic-components'
import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import useErrorSnackBar from 'src/app/hooks/error-snack-bar/error-snack-bar'

export type CompanyNameValue = {
  physicalPerson: boolean
  lastName?: string
  firstName?: string
  name?: string
}

export type CompanyNameInputProps = {
  onCervedSearchClick: (searchText: string) => void
  value?: CompanyNameValue
  onChange: (value: CompanyNameValue) => void
  size?: 'small' | 'medium'
  disabled?: boolean
  physicalPersonLabel: string
  firstNameLabel: string
  lastNameLabel: string
  nameLabel: string
  error?: {
    lastName?: { message?: string }
    firstName?: { message?: string }
    name?: { message?: string }
  }
}

export const CompanyNameInput = forwardRef((props: CompanyNameInputProps, inputRef) => {
  const { value, onChange, physicalPersonLabel, disabled, firstNameLabel, error, lastNameLabel, nameLabel, size, onCervedSearchClick } = props
  // const [localValue, setLocalValue] = useState<CompanyName>(value ? getLocalValue(value) : { physicalPerson: false, name: '' })
  const showError = useErrorSnackBar()
  const { t } = useTranslation()

  return (
    <Grid container spacing={1}>
      <Grid xs={12} item>
        <FormControlLabel //
          control={
            <Switch //
              onChange={(event, newValue) => {
                const physicalPerson = newValue
                if (physicalPerson) {
                  onChange({ physicalPerson: true, lastName: '', firstName: '' })
                } else {
                  onChange({ physicalPerson: false, name: '' })
                }
              }}
              checked={value?.physicalPerson ?? false}
              disabled={disabled}
              /*size={size}*/
            />
          }
          label={physicalPersonLabel}
        />
      </Grid>
      {value?.physicalPerson ? (
        <>
          <Grid xs={12} md={6} item>
            <FormItem //
              fullWidth
              fieldLabel={`${lastNameLabel}*`}
              errorMessage={error?.lastName?.message}
            >
              <TextField //
                disabled={disabled}
                size={size}
                fullWidth
                value={value?.lastName || ''}
                onChange={(event) => {
                  onChange({ ...value, lastName: event.target.value })
                }}
                error={error?.lastName ? true : false}
                inputRef={inputRef}
              />
            </FormItem>
          </Grid>
          <Grid xs={12} md={6} item>
            <FormItem //
              fullWidth
              fieldLabel={`${firstNameLabel}*`}
              errorMessage={error?.firstName?.message}
            >
              <TextField //
                disabled={disabled}
                size={size}
                fullWidth
                value={value?.firstName || ''}
                onChange={(event) => {
                  onChange({ ...value, firstName: event.target.value })
                }}
                error={error?.firstName ? true : false}
                inputRef={inputRef}
              />
            </FormItem>
          </Grid>
        </>
      ) : (
        <Grid xs={12} item>
          <Stack //
            direction="row"
            spacing={1}
            alignItems={'center'}
          >
            <FormItem //
              fullWidth
              fieldLabel={`${nameLabel}*`}
              errorMessage={error?.name?.message}
            >
              <TextField //
                disabled={disabled}
                size={size}
                fullWidth
                value={value?.name || ''}
                onChange={(event) => {
                  onChange({ ...value, physicalPerson: value?.physicalPerson ?? false, name: event.target.value })
                }}
                error={error?.name ? true : false}
                inputRef={inputRef}
                sx={{
                  '& svg': {
                    color: 'unset!important',
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Button //
                        onClick={() => {
                          if (!value?.physicalPerson) {
                            if (!value?.name) {
                              return showError(t('pms.common.customer.missing_company_name'))
                            }

                            onCervedSearchClick(value?.name)
                          }
                        }}
                        size={size}
                        disabled={disabled}
                        style={{ minWidth: 0, minHeight: 0 }}
                      >
                        <FontAwesomeIcon icon={faWandMagicSparkles} />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </FormItem>
          </Stack>
        </Grid>
      )}
    </Grid>
  )
})
